import React, { useEffect } from "react";
import lottie from "lottie-web";
// import { makeStyles } from '@material-ui/styles';

//import AOS from "aos";
//import AOSStyles from "./aos.scss";

import AnimalsStyles from './animals.module.scss';

// const useStyles = makeStyles(theme => ({
//   root: {

//   },
// }));

const Animals = (props) => {
  const animalName = props.animalName;

  useEffect(() => {
    if (animalName === "all") {

      lottie.loadAnimation({
        container: document.querySelector("#tiger"),
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: require("../asset/Tiger.json"),
      });
      lottie.loadAnimation({
        container: document.querySelector("#lion"),
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: require("../asset/lion.json"),
      });

      lottie.loadAnimation({
        container: document.querySelector("#elephant"),
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: require("../asset/elephant.json"),
      });
      lottie.loadAnimation({
        container: document.querySelector("#deer"),
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: require("../asset/deer.json"),
      });
      lottie.loadAnimation({
        container: document.querySelector("#dog"),
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: require("../asset/dog.json"),
      });
      lottie.loadAnimation({
        container: document.querySelector("#horse"),
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: require("../asset/horse.json"),
      });
      lottie.loadAnimation({
        container: document.querySelector("#boar"),
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: require("../asset/boar.json"),
      });
      lottie.loadAnimation({
        container: document.querySelector("#turtle"),
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: require("../asset/turtle.json"),
      });
      lottie.loadAnimation({
        container: document.querySelector("#camel"),
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: require("../asset/camel.json"),
      });
      lottie.loadAnimation({
        container: document.querySelector("#cow"),
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: require("../asset/cow.json"),
      });
    } else if (animalName !== "all") {
      lottie.loadAnimation({
        container: document.querySelector("#section_" + animalName),
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: require("../asset/" + animalName + ".json"),
      });
    }
  }, []);

  const translate = document.querySelectorAll(".translate");

  window.addEventListener("scroll", () => {
    let scroll = window.pageYOffset;

    translate.forEach((element) => {
      let speed = element.dataset.speed;

      element.style.transform = `translateY(${scroll * speed}px)`;
    });
  });

  if (animalName === "all") {
    return (
      <>
        <div className={AnimalsStyles.animalsBottomWrap}>
          <div className={AnimalsStyles.rightAnimalsWrap} id="right_animal">
            <div className={AnimalsStyles.tiger} id="tiger"></div>
            <div className={AnimalsStyles.lion} id="lion"></div>
            <div className={AnimalsStyles.elephant} id="elephant"></div>
            <div className={AnimalsStyles.deer} id="deer"></div>
            <div className={AnimalsStyles.dog} id="dog"></div>
            <div className={AnimalsStyles.bike} id="bike">
              <img src={process.env.PUBLIC_URL + "./images/landing/bike.png"} alt="bike" />
            </div>
          </div>

          <div className={AnimalsStyles.leftAnimalsWrap} id="left_animal">
            <div className={AnimalsStyles.cow} id="cow"></div>
            <div className={AnimalsStyles.boar} id="boar"></div>
            <div className={AnimalsStyles.horse} id="horse"></div>
            <div className={AnimalsStyles.camel} id="camel"></div>
            <div className={AnimalsStyles.turtle} id="turtle"></div>
            <div className={AnimalsStyles.roller} id="roller">
              <img src={process.env.PUBLIC_URL + "./images/landing/roller.png"} alt="roller" />
            </div>
          </div>
        </div>
      </>
    );
  } else if (animalName === "elephant") {
    return (
      <>
        <div style={{ position: "static", width: '100%', left: '0' }}>
          <div style={{ position: "static", width: '5vw', margin: '0 0 0 45%', zIndex: "25" }} id={"section_" + animalName}></div>
        </div>
      </>
    );
  } else if (animalName === "horse") {
    return (
      <>
        <div style={{ position: "static", width: '100%', left: '0' }}>
          <div style={{ position: "static", width: '6vw', margin: '24px 0 0 calc(55% - 7vw)', zIndex: "25" }} id={"section_" + animalName}></div>
        </div>
      </>
    );
  } else if (animalName === "lion") {
    return (
      <>
        <div style={{ position: "static", width: '100%', left: '0' }}>
          <div style={{ position: "static", width: '6vw', margin: '24px 0 0 45%', zIndex: "25" }} id={"section_" + animalName}></div>
        </div>
      </>
    );
  } else if (animalName === "boar") {
    return (
      <>
        <div style={{ position: "static", width: '100%', left: '0' }}>
          <div style={{ position: "static", width: '7vw', margin: '24px 0 0 calc(55% - 7vw)', zIndex: "25" }} id={"section_" + animalName}></div>
        </div>
      </>
    );
  } else if (animalName === "deer") {
    return (
      <>
        <div style={{ position: "static", width: '100%', left: '0' }}>
          <div style={{ position: "static", width: '7vw', margin: '24px 0 0 45%', zIndex: "25" }} id={"section_" + animalName}></div>
        </div>
      </>
    );
  }
};

export default Animals;
